export enum DtgListType {
    list
    ,modal
};